<template>
    <div class="flex flex-col justify-center items-center h-80">
      <img :src="`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_BASE_PATH}Loader.gif`" 
      class="w-20 h-20 mix-blend-multiply contrast-100" />
      <div v-if="title" class="font-bold text-base text-center text-[#2E2E2E]">{{ title  }}</div>
      <div v-if="loaderMessage" class="text-center mt text-sm font-normal text-[#2E2E2E]">{{ loaderMessage  }}</div>
    </div>
</template>

<script setup>
import { MEDIA_ASSET_BASE_URL, MEDIA_ASSET_BASE_PATH } from "@/config/constants"

defineProps({
  loaderMessage: String,
  title: {
    type: String,
    default: ''
  }
})
</script>